export default __webpack_public_path__ + "static/media/pager.d9bec7f1.png";